// import primary libraries
import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Link from 'react-router-dom/Link'
import {
	isPossiblePhoneNumber
} from 'react-phone-number-input'
import PhoneInput from 'react-phone-number-input/input'
import classNames from 'classnames'

// import form components
import SelectFromObject from '../../../global/components/forms/SelectFromObject.js.jsx'
import TextInput from '../../../global/components/forms/TextInput.js.jsx'

const PhoneNumberForm = ({
  cancelLink,
  disabled,
  formType,
  handleFormChange,
  handleFormSubmit,
  onCancel,
  phoneNumber
}) => {
  
  const [error, setError] = useState()

  // set the button text
  const buttonText =
    formType === 'create' ? 'Add Phone Number' : 'Update Phone Number'

  return (
    <div className="yt-container">
      <div className="yt-row center-vert">
        <div className="form-container">
          <form
            name="phoneNumberForm"
            className="phoneNumber-form"
            onSubmit={e => {
              if (e) {
                e.preventDefault()
              }
              if (isPossiblePhoneNumber(phoneNumber.number) && !phoneNumber.extNumberError) {
                handleFormSubmit(e)
              }
            }}
          >
            <div className="yt-row">
              <div className="yt-col _20">
                <SelectFromObject
                  items={[
                    'mobile',
                    'home',
                    'work',
                    'main',
                    'home fax',
                    'work fax',
                    'other fax',
                    'other',
                  ]}
                  change={handleFormChange}
                  name="phoneNumber.type"
                  selected={phoneNumber.type}
                  placeholder="-- Type -- "
                />
              </div>
              <div className="yt-col -phone-input input-group">
                <PhoneInput
                  className={classNames({ '-error': !!error })}
                  autoFocus={formType === 'create'}
                  country="US"
                  onChange={value => {
                    handleFormChange({
                      target: { name: 'phoneNumber.number', value: value },
                    })
                    if (!value) {
                      setError('Phone number required')
                      return
                    }
                    if (!isPossiblePhoneNumber(value)) {
                      setError('Phone number not valid')
                      return
                    }
                    setError(undefined)
                  }}
                  placeholder="Phone Number (required)"
                  value={phoneNumber.number || ''}
                />
                {!!error && <div className="-error-message">{error}</div>}
              </div>
              <TextInput
                classes="yt-col _20 -phone-input"
                change={handleFormChange}
                label=""
                placeholder="Ext(max 20)"
                name="phoneNumber.extNumber"
                value={phoneNumber.extNumber}
                errorName="phoneNumber.extNumberError"
                error={phoneNumber.extNumberError}
                validationRegex={/^[a-zA-Z0-9]{0,20}$/}
                errorText={'Extension is too long or contains invalid characters'}
              />
              {/* {
                phoneNumber && phoneNumber._user ? 
                <TextInput
                  classes="yt-col _20 -phone-input"
                  change={handleFormChange}
                  label="Ext"
                  name="phoneNumber.extNumber"
                  value={phoneNumber.extNumber}
                /> : null
              }               */}
            </div>
            <div className="input-group">
              <div className="yt-row space-between">
                {cancelLink ? (
                  <Link
                    className="yt-btn link small"
                    to={cancelLink}
                  >
                    Cancel
                  </Link>
                ) : onCancel ? (
                  <button
                    className="yt-btn link x-small danger"
                    type="button"
                    onClick={onCancel}
                  >
                    {' '}
                    Cancel{' '}
                  </button>
                ) : null}
                <button
                  className="yt-btn link x-small info"
                  disabled={disabled || !!error || !!phoneNumber.extNumberError}
                  type="submit"
                >
                  {' '}
                  {buttonText}{' '}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

PhoneNumberForm.propTypes = {
  cancelLink: PropTypes.string,
  formHelpers: PropTypes.object,
  formTitle: PropTypes.string,
  formType: PropTypes.string.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  phoneNumber: PropTypes.object.isRequired,
}

PhoneNumberForm.defaultProps = {
  formHelpers: {},
  formTitle: '',
}

export default PhoneNumberForm
